import { render } from "./SemakanKiteJer.vue?vue&type=template&id=9f554b88"
import script from "./SemakanKiteJer.vue?vue&type=script&lang=js"
export * from "./SemakanKiteJer.vue?vue&type=script&lang=js"

import "./SemakanKiteJer.vue?vue&type=style&index=0&id=9f554b88&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__